setTimeout(() => {
    $('.modal #reason, #reason').each(function () {
        const element = $(this);
        const parentWrapper = element.parent().parent();
        const tipReasonAlert = parentWrapper.find('#tip-reason');

        switchInfoBlock(tipReasonAlert, element.val());

        element.on('change', function () {
            tipReasonAlert.hide();
            switchInfoBlock(tipReasonAlert, element.val(), 500);
        });

        function switchInfoBlock(alert, value, speed = null) {
            switch (value) {
                case 'double_booked':
                    alert.show(speed);
                    break;
                case 'calendar_not_current':
                    alert.show(speed);
                    break;
                case 'other_converted':
                    alert.show(speed);
                    break;
                default:
                    alert.hide(speed);
                    break;
            }
        }
    });

}, 200);
